import store from '@/store/index';
import router from './index.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
router.beforeEach((to, from, next) => {
    NProgress.start()
    if (to.meta.title) {
        document.title = '圆梦-' + to.meta.title
    }
    if (from.path == "/search") {
        store.commit("setsearchtext", "");
    }
    next()
    NProgress.done()
})
router.afterEach(() => {
    NProgress.done() // finish progress bar
})